module.exports = __webpack_public_path__ + "img/图层 20.d1f38f6e.png";